export const amber50 = "#fdeee9";
export const amber100 = "#fde9da";
export const amber200 = "#fcd3b5";
export const amber300 = "#fabd91";
export const amber400 = "#f9a76c";
export const amber500 = "#f89248";
export const amber600 = "#f0783a";
export const amber700 = "#e85f2d";
export const amber800 = "#df451f";
export const amber900 = "#d72c12";
export const amber1000 = "#d11905";
export const amberA100 = "#fde981";
export const amberA200 = "#fbc86c";
export const amberA400 = "#f45b24";
export const amberA500 = "#ed0c05";
export const amberA1000 = "#563219";
